import { memo, useEffect, useState } from 'react';
import MapOutlinedIcon from '@material-ui/icons/MapOutlined';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import Button from '../../Button';
import { toggleMapVisibility } from '../../../store/slices/tripSearch';
import checkDoSkipTripConfiguration from '../../../helpers/selectors/checkDoSkipTripConfiguration';

const ShowHideTripItinerariesMap = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);
  const dispatch = useDispatch();
  const { travelAgency } = useSelector((store) => store.user);
  const doSkipTripConfiguration = useSelector(checkDoSkipTripConfiguration);
  const { selectedTrips } = useSelector((state) => state.trip);
  const { isMapShown } = useSelector((state) => state.tripSearch);

  const doDisableHotelsMap = travelAgency && travelAgency.settings
  && travelAgency.settings.doDisableHotelsMap;
  const handleToggleMap = () => {
    dispatch(toggleMapVisibility());
  };

  const defaultHideHotelsMap = travelAgency && travelAgency.settings
  && travelAgency.settings.defaultHideHotelsMap;
  useEffect(() => {
    if (defaultHideHotelsMap || (!doSkipTripConfiguration && selectedTrips
      && _.find(selectedTrips, (t) => !!t))) {
      dispatch(toggleMapVisibility(false));
    }
  }, [defaultHideHotelsMap, dispatch, doSkipTripConfiguration, selectedTrips]);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 640px)');
    const handleMediaQueryChange = (event) => {
      setIsMobile(event.matches);
    };
    handleMediaQueryChange(mediaQuery);
    mediaQuery.addEventListener('change', handleMediaQueryChange);
    return () => {
      mediaQuery.removeEventListener('change', handleMediaQueryChange);
    };
  }, []);

  useEffect(() => {
    if (isMobile) {
      dispatch(toggleMapVisibility(false));
    } else if (!defaultHideHotelsMap) {
      dispatch(toggleMapVisibility(true));
    }
  }, [defaultHideHotelsMap, dispatch, isMobile]);

  return (
    !doDisableHotelsMap ? (
      <Button variant={Button.buttonVariants.OUTLINE_WHITE_BG} className="py-2 px-3 text-base" onClick={handleToggleMap}>
        <>
          <MapOutlinedIcon style={{ fontSize: '1.1em' }} className="mr-1" />
          {`${isMapShown ? 'Hide Map' : 'Show Map'}`}
        </>
      </Button>
    ) : <></>
  );
};

export default memo(ShowHideTripItinerariesMap);
